import React, { memo } from 'react';
import { useFragment, graphql } from 'react-relay';
import type { IssueTypeCell$key } from '@atlassian/jira-relay/src/__generated__/IssueTypeCell.graphql';
import { IconCell } from '../../icon-cell/IconCell.tsx';

type Props = {
	fieldRef: IssueTypeCell$key;
};

export const IssueTypeCell = memo(({ fieldRef }: Props) => {
	const data = useFragment<IssueTypeCell$key>(
		graphql`
			fragment IssueTypeCell on JiraIssueTypeField {
				...IconCell
			}
		`,
		fieldRef,
	);

	return <IconCell fragmentRef={data} showErrorIconWhenEmpty />;
});
